export const CONSONANT_VOWEL_PAIRS_K_G = [

    // ㄱ
    {
        id: 1,
        korean: "가",
        english: "ka/ga",

    },
    {
        id: 2,
        korean: "게",
        english: "ke/ge",

    },
    {
        id: 3,
        korean: "기",
        english: "ki/gi",

    },
    {
        id: 4,
        korean: "고",
        english: "ko/go",

    },
    {
        id: 5,
        korean: "그",
        english: "keu/geu",

    },
    {
        id: 6,
        korean: "거",
        english: "keo/geo",

    },
    {
        id: 7,
        korean: "갸",
        english: "kya/gya",

    },
    {
        id: 8,
        korean: "걔",
        english: "kae/gae",

    },
    {
        id: 9,
        korean: "계",
        english: "kye/gye",

    },
    {
        id: 10,
        korean: "교",
        english: "kyo/gyo",

    },
    {
        id: 11,
        korean: "겨",
        english: "kyoe,gyoe",

    },
    {
        id: 12,
        korean: "규",
        english: "kyu/gyu",

        

    },

    {
        id: 13,
        korean: "간",
        english: "kan/gan",

        

    },
    {
        id: 14,
        korean: "각",
        english: "kak/gak",

        

    },
    {
        id: 15,
        korean: "김",
        english: "kim/gim",
        

    },
    {
        id: 16,
        korean: "갓",
        english: "kat/gat",
        

    },
    {
        id: 17,
        korean: "갛",
        english: "kah/gah",
        

    },
    {
        id: 18,
        korean: "겁",
        english: "keob/geob",
        

    },
          {
        id: 19,
        korean: "곌",
        english: "kyel/gyel",
        

    },
    {
        id: 20,
        korean: "갖",
        english: "kat/gat",
        

    },
    {
        id: 21,
        korean: "갞",
        english: "kaekk/gaekk",
        

    },
    {
        id: 22,
        korean: "걘",
        english: "kaen/gaen",
        

    },
    {
        id: 23,
        korean: "긔",
        english: "kui/gui",
        

    },
    {
        id: 24,
        korean: "귀",
        english: "kwo/gwo",
        

    },

    {
        id: 25,
        korean: "걑",
        english: "kyat/gyat",
        

    },
    {
        id: 26,
        korean: "과",
        english: "kwa/gwa",
        

    },
    {
        id: 27,
        korean: "강",
        english: "kang/gang",
        
    },
    {
        id: 28,
        korean: "겍가",
        english: "keg-ga",
        
    },
    {
        id: 29,
        korean: "고가",
        english: "ko-ga",
        
    },
    {
        id: 30,
        korean: "긱옥",
        english: "ki-gok",
        
    },
    {
        id: 31,
        korean: "극아",
        english: "keu-ga",
        
    },
    {
        id: 32,
        korean: "혹",
        english: "hok",
        
    },
    {
        id: 33,
        korean: "귝거",
        english: "kyug-geo",
        
    }
    
];

